import AuthService from '../services/auth.service';
const API_URL = AuthService.getAPIUrl()
const AI_API_URL = AuthService.getAIUrl();

export const settings = {
	namespaced: true,
	state: {
		api_base: API_URL,
		ai_api_base: AI_API_URL,
		is_loading: false,
		loading_message: "Please wait...Your data is loading",
		show_basic_modal: false,
		auto_refresh: false,
		ignore: false,
		is_page_mounted: false
	},
	mutations: {
		setIsLoading(state,	payload)
		{
			if (state.ignore || !state.is_page_mounted) return;
			state.is_loading = payload;
		},
		setLoadingMessage(state,payload)
		{
			if (state.ignore) return;
			state.loading_message = payload;
		},
		setShowBasicModal(state, payload)
		{
			if (state.ignore) return;
			state.show_basic_modal = payload;
		},
		setAutoRefresh(state, payload)
		{
			if (state.ignore) return;
			state.auto_refresh = payload;
		},
		setIgnore(state, payload)
		{
			state.ignore = payload;
		},
		setPageMounted(state, payload)
		{
			state.is_page_mounted = payload;
		}
	},
	getters: {
	},
};
